import { tButtonClickHandler } from "../types"

export const clearGridSelection: tButtonClickHandler = (e, { gridApi }) => {
    gridApi.deselectAll()
    gridApi.clearFocusedCell()
}
